import { RootState } from 'editor/src/store/index';

const isAnyMediaElementInCropMode = (state: RootState) => state.editor.cropModeElementUuid !== undefined;

export default isAnyMediaElementInCropMode;
